import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Button,
  SpaceBetween,
  Tabs,
  Box,
  Header,
  Table as CSDTable,
} from "@cloudscape-design/components-themed";
import { DEFAULT_PAGE_SIZE } from "../../configs/constants";
import Preference from "../UI/Preference";
import Pagination from "../UI/Pagination";
import { getHeaderCounterText, getPagedItems } from "../../utils/common";
import { formatDate } from "../../utils/format";
import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";
import { IndividualCounselingProjectContract } from "../../features/api-interfaces";

const columnDefinitions = [
  {
    id: "individualConsultationBranchNo",
    header: LABELS.BRANCH_NO,
    cell: (e: any) => e.individualConsultationBranchNo,
  },
  {
    id: "merchantName",
    header: LABELS.MERCHANT_NAME,
    cell: (e: any) => (
      // 個別相談案件相談内容登録・更新
      <Link
        to={
          // "/individual-counseling-project/" +
          // e.individual_consultation_no +
          // "/" +
          // e.individualConsultationBranchNo
          "/individual-counseling-project-content/" +
          e.individualConsultationNo +
          "/" +
          e.individualConsultationBranchNo
        }
      >
        {e.merchantName}
      </Link>
    ),
  },
  {
    id: "contractServiceName",
    header: LABELS.CONTRACT_SERVICE_NAME,
    cell: (e: any) => e.contractServiceName,
  },
  {
    id: "contractStyle",
    header: LABELS.CONTRACT_STYLE,
    cell: (e: any) => e.contractStyleLabel,
  },
  {
    id: "contractRoute",
    header: LABELS.CONTRACT_ROUTE,
    cell: (e: any) => e.contractRoute,
  },
  {
    id: "considerationPolicy",
    header: LABELS.CONSIDERATION_POLICY,
    cell: (e: any) => e.considerationPolicy,
  },
  {
    id: "considerationStatus",
    header: LABELS.CONSIDERATION_STATUS,
    cell: (e: any) => e.considerationStatus,
  },
  {
    id: "lastUpdatedDate",
    header: LABELS.LAST_UPDATED_DATE,
    cell: (e: any) => e.updateAtyyyyMMdd,
  },
];

export const Tab = (props: any) => {
  const navigate = useNavigate();
  const { individualConsultationNo } = useParams();
  // データをセット
  const individualCounselingProjectContractList: IndividualCounselingProjectContract[] =
    props.IndividualCounselingProjectContractData;

  const formatStyle = (contractStyle: number): string => {
    if (contractStyle === 1) {
      return LABELS.TAB_CONTRACT_STYLE_DIRECT;
    } else if (contractStyle === 2) {
      return LABELS.TAB_CONTRACT_STYLE_INCLUSION;
    } else if (contractStyle === 3) {
      return LABELS.TAB_CONTRACT_STYLE_EXAMINATION;
    } else {
      return "";
    }
  };

  // 一覧データの加工
  const listData = individualCounselingProjectContractList
    ? individualCounselingProjectContractList.map((item) => ({
        ...item,
        updateAtyyyyMMdd: formatDate(item.updatedAt),
        contractStyleLabel: formatStyle(item.contractStyle),
      }))
    : [];

  /**ページャ関連 */
  const options = columnDefinitions.map((column) => ({
    id: column.id,
    label: column.header,
  }));
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [preferences, setPreferences] = useState({
    pageSize: DEFAULT_PAGE_SIZE,
    visibleContent: options.map((o) => o.id),
  });

  const [pagedItems, setPagedItems] = useState<Object[]>([]);
  const [allItems, setAllItems] = useState<Object[]>([]);
  useEffect(() => {
    if (listData !== undefined && !Object.keys(pagedItems).length) {
      setPagedItems(getPagedItems(listData, 1, DEFAULT_PAGE_SIZE));
      setAllItems(listData);
      setCurrentPageIndex(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [individualCounselingProjectContractList]);

  /** 設定変更関数 */
  const handleOnConfirm = (detail: any) => {
    const newPageSize = detail.pageSize;
    setPreferences({
      pageSize: newPageSize,
      visibleContent: detail.visibleContent,
    });
    setPagedItems(listData.slice(0, newPageSize));
    setCurrentPageIndex(1);
  };

  return (
    <Tabs
      variant="container"
      tabs={[
        {
          label: LABELS.TAB_TITLE_INDIVIDUAL_CONSULTATION_PROJECT_LIST,
          id: "first",
          content: (
            <CSDTable
              columnDefinitions={columnDefinitions}
              items={pagedItems}
              loading={props.isFetching}
              loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
              resizableColumns
              stickyHeader
              header={
                <SpaceBetween size="xs">
                  <SpaceBetween direction="horizontal" size="l">
                    <Button
                      onClick={() => {
                        navigate(
                          "/individual-counseling-project-content/register/" +
                            individualConsultationNo
                        );
                      }}
                    >
                      {LABELS.INDIVIDUAL_CONSULTATION_PROJECT_TITLE}
                    </Button>
                  </SpaceBetween>
                  <Header>
                    {LABELS.TAB_TITLE}
                    {getHeaderCounterText(allItems.length, pagedItems.length)}
                  </Header>
                </SpaceBetween>
              }
              pagination={
                <Pagination
                  currentPageIndex={currentPageIndex}
                  filteredItems={allItems}
                  setCurrentPageIndex={setCurrentPageIndex}
                  pageSize={preferences.pageSize}
                  setPagedItems={setPagedItems}
                />
              }
              preferences={
                <Preference
                  preferences={preferences}
                  options={options}
                  handleOnConfirm={handleOnConfirm}
                />
              }
              empty={
                <Box textAlign="center" color="inherit">
                  {COMMON_LABELS.CSD.NO_DATA}
                </Box>
              }
            ></CSDTable>
          ),
        },
      ]}
    />
  );
};
